window._ = require("lodash");

import Vue from 'vue';

import "./plugins/validate";
import "./plugins/axios";
import "./plugins/filter";

import '@mdi/font/css/materialdesignicons.css';

import app from "./components/Pdv/Index.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";

import MoneyInput from "./components/MoneyInput.vue";
import Input from "./components/Input.vue";

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import VueMask from 'v-mask';

import LoaderPlugin from './plugins/loader'

Vue.use(LoaderPlugin)

Vue.use(VueMask);

Vue.component("MoneyInput", MoneyInput);
Vue.component("Input", Input);


window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'a9213b66579316fc5f80',
    cluster: 'sa1',
    forceTLS: true
});



new Vue({
    vuetify,
    store,
    render: h => h(app)
}).$mount("#app");
